<div class="d-flex justify-content-center">
  <div class="spinner-border" role="status" >
    <span class="sr-only" id="loading"></span>
  </div>
</div>
